import React from 'react';
import styles from './styles.module.css';
import { getLocalString, getLocalUrl } from '../../languages';
export function PrivacyLink ({ orgId } = {}) {
  return(
    <div className={styles['footerStyle']}>
      <span>© {getLocalString('copyright_company', 'Zinier Inc.', orgId)} </span>
      <a
        href={getLocalUrl('terms_and_conditions_link',
          'https://www.zinier.com/terms-conditions/', orgId)}
        target="_blank"
        rel="noopener noreferrer">
        {`• ${getLocalString('terms_and_conditions',
          'Terms & Conditions', orgId)}`} </a>
      <a
        href={getLocalUrl('privacy_policy_link',
          'https://www.zinier.com/privacy-policy-app/', orgId)}
        target="_blank"
        rel="noopener noreferrer">
        {`• ${getLocalString('privacy_policy',
          'Privacy Policy', orgId)}`} </a>
    </div>);
}


